// import { set, toggle } from '@/utils/vuex'

export default {
  setSubmittingMasterpayer (state, submitting) {
    state.submitting = submitting
  },
  clearRequest (state) {
    state.request = {
      dedicatedMasterAccount: null, 
      accountModel: null,
      sppContractType: null,
      awsSupportLevel: null,
      linkedAccountsType: null,
      contractSignatureDate: null,
      opportunityId: null,
      edpContract: null,
      controlTowerRequired: null,
      clientName: null,
      clientSfdcid: null,
      serviceLine: null,
      businessUnit: null,
      saasModel: null,
      businessJustification: null,
      controlTowerRegions: null,
      controlTowerGuardRail: null,
      controlTowerCloudTrail: null,
      requestorName: null,
      requestorEmail: null,
      requestorId: null,
    }
  },
  setMasterpayerListLoading (state, toggle) {
    state.masterpayerRequestLoading = toggle
  },
  clearMasterpayerRequest (state) {
    state.masterpayerRequest = []
  },
  setMasterpayerRequest (state, data) {
    console.log('setting mp')
    console.log(data)
    state.masterpayerRequest = data
  }
}
